import React, { useEffect, useState } from 'react';

const goals = ["ניהול הזמנות בצורה ברורה ומהירה", "חיבור בין עמדת לקוח, מטבח וצוות שירות", "הפחתת עומס ושגיאות בזמן עבודה", "חוויה רגועה יותר ללקוחות ולעובדים"];

function App() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 150);
    return () => clearTimeout(timer);
  }, []);

  return (
    <main className={`page ${loaded ? 'show' : ''}`}>
      <section className="hero">
        <nav className="nav">
          <div className="brand">
            <span className="brandIcon">▦</span>
            <span>Servix</span>
          </div>
          <a className="contact" href="https://mbvipsoft.com">MBVIP SOFT</a>
        </nav>

        <div className="heroGrid">
          <div className="content">
            <span className="badge">בקרוב • שלב פיתוח</span>
            <h1>Servix נבנית בקפידה כדי לתת חוויה יציבה, חכמה ונעימה יותר.</h1>
            <p>מערכת שירות חכמה לניהול הזמנות, צוותים ותהליכי עבודה בזמן אמת</p>
            <div className="actions">
              <a href="https://mbvipsoft.com" className="primary">חזרה לאתר הראשי</a>
              <a href="#goals" className="secondary">מה אנחנו בונים?</a>
            </div>
          </div>

          <div className="visual" aria-label="תצוגה גרפית של המערכת">
            <div className="screen">
              <div className="screenTop"><span></span><span></span><span></span></div>
              <div className="screenBody">
                <div className="pulse"></div>
                <div className="lines">
                  <i></i><i></i><i></i>
                </div>
                <div className="cards"><b></b><b></b><b></b></div>
              </div>
            </div>
            <div className="orb orbOne"></div>
            <div className="orb orbTwo"></div>
          </div>
        </div>
      </section>

      <section className="status">
        <div><strong>עיצוב</strong><span>בתהליך ליטוש</span></div>
        <div><strong>פיתוח</strong><span>בניית תשתית יציבה</span></div>
        <div><strong>חוויה</strong><span>נוחות, מהירות ובהירות</span></div>
      </section>

      <section id="goals" className="goals">
        <h2>המטרות שלנו</h2>
        <div className="goalGrid">
          {goals.map((goal, index) => (
            <article className="goal" key={goal}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <p>{goal}</p>
            </article>
          ))}
        </div>
      </section>

      <footer>
        <p>אנחנו בונים לאט, חכם ומדויק — כדי שהמערכת שתקבלו תהיה ראויה לאמון שלכם.</p>
      </footer>
    </main>
  );
}

export default App;
